import { createAction, props } from '@ngrx/store';
import { CommunicationCategory } from './communication-category.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records communication category'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records communication category success', 
    props<{ listData: CommunicationCategory[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records communication category failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record communication category',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record communication category success', 
    props<{ singleData: CommunicationCategory }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record communication category failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record communication category',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record communication category success'
);
export const addRecordFailure = createAction(
    '[Data] Add record communication category failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record communication category',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record communication category success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record communication category failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record communication category',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record communication category success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record communication category failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state communication category',
);